import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import { AboutSection, AppSection, ContactSection } from './components/InfoSections';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import { FeaturesSection, MediaSection } from './components/FeaturesMediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <CommentsSection />
        <IndexSection />
        <AboutSection />
        <AppSection />
        <ContactSection />
        <FaqSection />
        <UpdatesSection />
        <RankingSection />
        <TopicsSection />
        <CarouselSection />
        <FeaturesSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}